import React from "react";
import { CPDropdown } from "./CPDropdown";
import { useMembership } from "../context/MembershipContext";
import { switchActiveOrganization } from "../helpers/membershipInvitations";

/**
 * Shown when the user has multiple active organization memberships.
 */
export function OrganizationSwitcher({ className = "" }) {
  const {
    memberships,
    organizationId,
    setCurrentOrganizationId,
    loading,
  } = useMembership();

  if (loading || !memberships || memberships.length <= 1) {
    return null;
  }

  const options = memberships.map((row) => ({
    value: row.organization_id,
    label: `${row.employee_name || "Member"} (${row.role})`,
  }));

  const handleChange = (nextOrgId) => {
    try {
      switchActiveOrganization(nextOrgId, {
        setCurrentOrganizationId,
        memberships,
      });
    } catch (err) {
      console.error("[OrganizationSwitcher]", err);
    }
  };

  return (
    <div className={className}>
      <CPDropdown
        label="Active organization"
        value={organizationId || ""}
        onChange={handleChange}
        options={options}
      />
    </div>
  );
}
